import React from "react";
import {
    Grid,
    Stack,
    Typography,
    Button,
} from "@mui/material";

import { ReactComponent as GogoLogoIcon } from '../../assets/GogoLogoIcon.svg'
import { theme } from '../../theme/theme'

export const UnauthorizedPage = (props) => {
    return (
        <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh', backgroundColor: '#112334' }}
        >
            <Stack alignItems="center" sx={{
                width: 828,
                boxShadow: '0px 3px 6px #00000034;',
                borderRadius: 10,
            }}>
                <Stack direction="row" justifyContent="center" sx={{
                    backgroundColor: '#0A1826',
                    width: '100%',
                    p: 3,
                }}>
                    <GogoLogoIcon width={101.4585} height={47.733} />
                </Stack>
                <Stack direction="row" justifyContent="center" sx={{ backgroundColor: '#2C5877', width: '100%' }}>
                    <Typography
                        color="white"
                        fontSize={24}
                        textAlign="center"
                        sx={{ py: 3, px: 10 }}
                    >
                        You do not currently have access to the Cloud System Dashboard Site
                    </Typography>
                </Stack>
                <Stack direction="row" justifyContent="center" sx={{ backgroundColor: '#0A1826', width: '100%' }}>
                    <Stack>
                        <Typography
                            color="white"
                            fontSize={20}
                            textAlign="center"
                            sx={{ py: 3, px: 10 }}
                        >
                            Please contact the NetOps team to request access
                        </Typography>
                        <Stack direction="row" justifyContent="center">
                            <Button href="/" sx={{ 
                                color: theme.palette.tertiary.contrastText, 
                                backgroundColor: theme.palette.tertiary.main,
                                marginBottom: 3
                            }}>Back to Login</Button>
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>   
        </Grid> 
    )
}
export default UnauthorizedPage;